import { render, staticRenderFns } from "./balance-info.vue?vue&type=template&id=9bcef4bc&scoped=true&"
import script from "./balance-info.vue?vue&type=script&lang=js&"
export * from "./balance-info.vue?vue&type=script&lang=js&"
import style0 from "./balance-info.vue?vue&type=style&index=0&id=9bcef4bc&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9bcef4bc",
  null
  
)

export default component.exports